module.exports = __webpack_public_path__ + "static/img/018_TO8_1479_og.2ddba49.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/018_TO8_1479_og.jpg
// module id = GcRB
// module chunks = 0